import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import MenuApi from "api/menu.api";
import {serviceMenuDestroy, serviceMenuOrder, serviceMenuSave, serviceMenuUpdateAction} from "services/menu.service";

const MenuContext = createContext();

export const MenuProvider = ({children}) => {

    const translateKey = 'crm.Menu';
    const permission = 'menu';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false,
        widget: false,
        widgetForm: false,
    });

    const {dataSource, setDataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(MenuApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id) => {
        const res = await serviceMenuUpdateAction(id);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await serviceMenuDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await serviceMenuSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const handleOrderChange = async (value, id) => {
        const index = dataSource.data.findIndex(i => i.id === id);
        dataSource.data[index].order = value;
        setDataSource(d => ({
            ...d,
            data: [...dataSource.data]
        }));
    }

    const handleOrderSave = async (value, id) => {
        if (value && id) {
            const res = await serviceMenuOrder(id, {order: value});
            if (res) {
                await fetchDataSource()
            }
        }
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave,
        handleOrderChange,
        handleOrderSave
    };

    return <MenuContext.Provider value={values}>
        {children}
    </MenuContext.Provider>
}

export const useMenuContext = () => useContext(MenuContext);
